import React, { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import SuccessToast from "../../../components/successToast";
import ValidationErrorToast from "../../../components/validationErrorToast";
import { api } from "../../../middleware/api";
import { actionCreators, State } from "../../../store";
import { STRING_CONSTANTS } from "../../../utils/constants/stringConstants";
import { UtilityFunctions, modifiedSalaray, timeConvrter } from "../../../utils/UtilityFunctions";
import { cookieService, userService } from "../../../_services";
import { Data } from "../../../_services/collections";
import ReactPlayer from 'react-player/lazy';
import parse from "html-react-parser";
//import CourseJobListing from "./CourseJobListing";
import moment from "moment";
import NoVerifyModal from "../../../components/noVerifyModal";

const CourseSidebar = (props: any) => {
    const [selectedCourse, setSelectedCourse] = useState<any>();
    const [userDeleted, setUserDeleted] = useState(false);
    const [playVideo, setPlayVideo] = useState(false)
    const dispatch = useDispatch();
    const { setCoursesList, setRemoveCourse, setSidebar } = bindActionCreators(actionCreators, dispatch);
    const reduxState = useSelector((state: State) => state);
    const isUserLoggedIn = cookieService.getCookie(STRING_CONSTANTS.cookieStrings.token)
    const userTypeCookieval = cookieService.getCookie(STRING_CONSTANTS.cookieStrings.user)
    const [notVerifiedModal, setNotVerifiedModal] = useState(false)
    const selectedCourseDetails = (jobId = "", isTrue = false) => {
        if (!isUserLoggedIn) {
            api.get(`${props?.selectedCourse?.id}/course/`, null)
                .then(res => {
                    setSelectedCourse(res)
                    props?.setSelectedUser(res)
                    setUserDeleted(false)
                })
                .catch(e => {
                    document.body.classList.add("loading-indicator");
                    // setUserDeleted(true)
                    props?.setUserExists(false)
                })
        }
        else if (userTypeCookieval?.user.type === STRING_CONSTANTS.userType.employer) {
            let SELECTEDEMPLOYEEID = props?.selectedCourse?.id ? props?.selectedCourse?.id : reduxState?.common?.uniquecourseId;
            let SELECTEDJOBID = props?.selectedJobID ? props?.selectedJobID : reduxState?.common?.uniqueId;
            userService.showCourseSidebar(SELECTEDEMPLOYEEID, SELECTEDJOBID)
                .then(res => {
                    setSelectedCourse(res)
                    props?.setSelectedUser(res)
                    setUserDeleted(false)
                })
                .catch(e => {
                    props.closeModalForcefully();
                    const elements = document.getElementsByClassName('modal-backdrop fade show');
                    while (elements.length > 0) {
                        elements[0].parentNode.removeChild(elements[0]);
                    }
                    ValidationErrorToast(e?.[0], e?.[1])
                    setUserDeleted(true)
                    props?.setUserExists(false)
                })
        }
        else {
            let id = ""
            if (isTrue && jobId) {
                id = jobId
            }
            else if (reduxState?.common?.uniqueId && !isTrue) {
                id = props?.selectedJobID ? props?.selectedJobID : reduxState?.common?.uniqueId;
            }
            else {
                id = props?.selectedCourse?.id
            }
            if (reduxState?.common?.show_sidebar) { // only side is open then call job detail open api other it will not called.
                api.get(`${id}/job/`, null)
                    .then((res: any) => {
                        // setSelectedCourse(res)
                        setUserDeleted(false)
                        props?.setSelectedUser(res)
                    })
                    .catch(e => {
                        props.closeModalForcefully();
                        const elements = document.getElementsByClassName('modal-backdrop fade show');
                        while (elements.length > 0) {
                            elements[0].parentNode.removeChild(elements[0]);
                        }
                        ValidationErrorToast(e?.[0], e?.[1])
                        setUserDeleted(true)
                        props?.setUserExists(false)
                    })
            }

        }
    }
    useEffect(() => {
        if (reduxState?.common?.uniqueId || reduxState?.common?.uniqueId && reduxState?.common?.uniquecourseId) {
            selectedCourseDetails();
        }
    }, [reduxState?.common?.uniqueId, (reduxState?.common?.uniqueId && reduxState?.common?.uniquecourseId)])

    useEffect(() => {
        if ((props?.selectedCourse?.id) || !isUserLoggedIn) {
            selectedCourseDetails();
            props?.setFlagReasons([]);
            props?.setFlag(true);
        }
    }, [props?.selectedCourse])

    const handleSendRequest = (course) => {
        const erID = cookieService.getCookie(STRING_CONSTANTS.cookieStrings.user) as Data
        const eeList = [...reduxState.coursesList]
        eeList.splice(reduxState.coursesList.findIndex((ee) => ee.id == course.id), 1, { ...course, chatRequested: true, requestedByUser: true })
        // if (!course?.chatRequested) {
        //     api.post('chat/rooms/', {
        //         "employerId": `${erID.user.id}`,
        //         "courseId": `${course?.user?.id}`,
        //         "jobId": `${props?.selectedJobID}`
        //     }).then(res => {
        //         setCoursesList(eeList)
        //         selectedCourseDetails()
        //         SuccessToast(STRING_CONSTANTS.SUCCESS_MESSAGES.CHAT, STRING_CONSTANTS.SUCCESS_MESSAGES.CHAT_REQUEST_SENT)
        //     }).catch(e => {
        //         ValidationErrorToast(e[0], e[1])
        //     })
        // }
        // if (!course?.chatRequested) {
        let params = {};
        // console.log(course, "course");
        // let idCourseEmployer;
        if (userTypeCookieval?.user.type === STRING_CONSTANTS.userType.employer) {
            // employer
            // idCourseEmployer = course?.user?.id;
            params = {
                employerId: erID.user.id,
                courseId: course?.user?.id,
                jobId: props?.selectedJobID
            }
        } else {
            // course
            // idCourseEmployer = course?.employer?.user?.id;
            params = {
                "employerId": `${course?.employer?.user?.id}`,
                "courseId": `${erID.user.id}`,
                "jobId": `${course?.id}`
            }
        }
        api.post('chat/rooms/', params).then(res => {
            selectedCourseDetails();
            setCoursesList(eeList);

            props?.history.push(`/dashboard/chat?chatid=${res?.data?.room?.id}`)
            // SuccessToast('Chat Request Sent', "")
        }).catch(e => {
            ValidationErrorToast('Error occured!', 'Please try again after some time')
        })
        // }
    }
    // const handleReceivedRequest = {
    //     handleChatAccept: (course) => {
    //         api.patch(`${course?.chatRoomId}/chat/`,
    //             {
    //                 "isActive": true
    //             })
    //             .then(res => {
    //                 props?.history.push(`/dashboard/chat?chatid=${res?.data?.["id"]}`)
    //                 // props?.history?.push("chat/", { chatInfo: { id: res?.data?.["id"] } })
    //                 setSidebar({ sidebar_name: "course-details", show_sidebar: false })
    //                 SuccessToast('Chat Request Accepted', "Request has been successfully accepted")
    //                 setRemoveCourse(course)
    //             })
    //             .then(() => {
    //                 props?.getChatRequests()
    //             })
    //             .catch(e => {
    //                 // ValidationErrorToast('Error occured!', 'Please try again after some time')
    //             })
    //     },
    //     handleChatReject: (course) => {
    //         api.patch(`${course?.chatRoomId}/chat/`,
    //             {
    //                 "isActive": false
    //             })
    //             .then(res => {
    //                 setSidebar({ sidebar_name: "course-details", show_sidebar: false })
    //                 // console.log(res)
    //                 SuccessToast('Chat Request Rejected', "Request has been rejected")
    //                 setRemoveCourse(course)
    //             })
    //             .then(() => {
    //                 props?.getChatRequests()
    //             })
    //             .catch(e => {
    //                 // ValidationErrorToast('Error occured!', 'Please try again after some time')
    //                 // console.log(e)
    //             })
    //     }
    // }

    const handleChatButton = (userObj) => {
        if (userTypeCookieval?.user.type === STRING_CONSTANTS.userType.employer) {
            //IF JOB STATUS IS ACTIVE
            if (userObj?.jobStatus == 'active') {
                //IF CHAT IS ACTIVE
                if (userObj?.chatRoomId)
                    return <button className="btn"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                        type="button"
                        onClick={() => {
                            props?.history.push(`/dashboard/chat?chatid=${userObj.chatRoomId}`)
                            setSidebar({ sidebar_name: "course-details", show_sidebar: false })
                        }}
                        style={{ backgroundColor: "#FFB800", color: "black" }}
                    >
                        {/* Chat */}
                        Ongoing Chat, Click Here
                    </button>
                //IF CHAT IS REJECTED
                // else if (userObj?.chatRejected)
                //     return <div></div>
                //IF CHAT IS REQUESTED BUT NOT REQUESTED BY USER 
                // else if (userObj?.chatRequested && !userObj?.requestedByUser) {
                //     return <>
                //         <button className='reject-btn'
                //             type="button"
                //             data-bs-dismiss="modal"
                //             aria-label="Close"
                //             onClick={() => {
                //                 handleReceivedRequest.handleChatReject(selectedCourse)
                //             }}>
                //             Reject
                //         </button>
                //         <button className="btn"
                //             data-bs-dismiss="modal"
                //             aria-label="Close"
                //             type="button"
                //             onClick={() => {
                //                 handleReceivedRequest.handleChatAccept(selectedCourse)
                //             }}
                //         >
                //             Chat
                //         </button>
                //     </>
                // }
                //IF CHAT IS REQUESTED BUT REQUESTED BY USER 
                // else if (userObj?.chatRequested && userObj?.requestedByUser)
                //     return <div className='btn-effect full-width-btn v-disabled-btn'>
                //         <button className='chat-btn' disabled
                //             type="button"
                //         >
                //             Chat Request Sent
                //         </button>
                //     </div>
                //IF CHAT IS NOT REQUESTED
                else return <div className="btn-effect full-width-btn">
                    <button className='btn'
                        type="button"
                        onClick={() => {
                            if (!isUserLoggedIn) { }
                            handleSendRequest(selectedCourse)
                        }
                        }>
                        {/* Send Chat Request */}

                        Start Chat
                    </button>
                </div>
            }
            else if (userObj?.jobStatus != 'active' && userObj?.chatRoomId) {
                return <button className="btn"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    type="button"
                    onClick={() => {
                        props?.history.push(`/dashboard/chat?chatid=${userObj.chatRoomId}`)
                        setSidebar({ sidebar_name: "course-details", show_sidebar: false })
                    }}
                    style={{ backgroundColor: "#FFB800", color: "black" }}
                >
                    {/* Chat */}
                    Ongoing Chat, Click Here
                </button>
            }
            // else return <div></div>
        } else {
            //IF JOB STATUS IS ACTIVE
            if (userObj?.status == 'active') {
                //IF CHAT IS ACTIVE
                if (userObj?.chatRoomId)
                    return <button className="btn"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                        type="button"
                        onClick={() => {
                            props?.history.push(`/dashboard/chat?chatid=${userObj.chatRoomId}`)
                            setSidebar({ sidebar_name: "course-details", show_sidebar: false })
                        }}
                        style={{ backgroundColor: "#FFB800", color: "black" }}
                    >
                        {/* Chat */}
                        Ongoing Chat, Click Here
                    </button>
                //IF CHAT IS REJECTED
                // else if (userObj?.chatRejected)
                //     return <div></div>
                //IF CHAT IS REQUESTED BUT NOT REQUESTED BY USER 
                // else if (userObj?.chatRequested && !userObj?.requestedByUser) {
                //     return <>
                //         <button className='reject-btn'
                //             type="button"
                //             data-bs-dismiss="modal"
                //             aria-label="Close"
                //             onClick={() => {
                //                 handleReceivedRequest.handleChatReject(selectedCourse)
                //             }}>
                //             Reject
                //         </button>
                //         <button className="btn"
                //             data-bs-dismiss="modal"
                //             aria-label="Close"
                //             type="button"
                //             onClick={() => {
                //                 handleReceivedRequest.handleChatAccept(selectedCourse)
                //             }}
                //         >
                //             Chat
                //         </button>
                //     </>
                // }
                //IF CHAT IS REQUESTED BUT REQUESTED BY USER 
                // else if (userObj?.chatRequested && userObj?.requestedByUser)
                //     return <div className='btn-effect full-width-btn v-disabled-btn'>
                //         <button className='chat-btn' disabled
                //             type="button"
                //         >
                //             Chat Request Sent
                //         </button>
                //     </div>
                //IF CHAT IS NOT REQUESTED
                else return <div className="btn-effect full-width-btn">
                    <button className='btn'
                        type="button"
                        onClick={() => {
                            if (!isUserLoggedIn) {
                                props?.setShowGuestAccessPrompt(true)
                            }
                            else if (!userTypeCookieval?.isAgeVerified) {
                                setNotVerifiedModal(true)
                            }
                            else {
                                handleSendRequest(selectedCourse)
                            }
                        }}>
                        {/* Send Chat Request */}
                        Start Chat
                    </button>
                </div>
            }
            else if (userObj?.status != 'active' && userObj?.chatRoomId) {
                return <button className="btn"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    type="button"
                    onClick={() => {
                        props?.history.push(`/dashboard/chat?chatid=${userObj.chatRoomId}`)
                        setSidebar({ sidebar_name: "course-details", show_sidebar: false })
                    }}
                    style={{ backgroundColor: "#FFB800", color: "black" }}
                >
                    {/* Chat */}
                    Ongoing Chat, Click Here
                </button>
            }
            else return <div></div>
        }
    }
    const handleClose = () => {
        setNotVerifiedModal(false);
    }
    const getUpdatedId = (job) => {
        selectedCourseDetails(job?.id, true)
        //props?.setSelectedCourse?.(job) ? props?.setSelectedCourse(job) : setSelectedCourse(job);
    }

    return (
        <>
            <NoVerifyModal show={notVerifiedModal} handleClose={handleClose} />
            <div className="modal-content" >
                <div className="modal-body">
                    {userDeleted ? <h3 style={{ color: "white" }}>This user doesn't exist</h3>
                        : !selectedCourse?.id  ? <h1 style={{ color: "white" }}>Loading...</h1>
                            : <>
                                <div className="prfile-se-mai d-grid align-content-between">
                                    <div className="profil-to">
                                        <div className='profile-detail-top'>
                                            <div className='d-flex justify-content-between'>
                                                <div className='prodetail-pic'>
                                                    {/* when you using course level */}
                                                    {/* <p className="mb-0">LVL 2</p> */}
                                                    {
                                                        userTypeCookieval?.user.type === STRING_CONSTANTS.userType.employer ?

                                                            <>
                                                                <img
                                                                    src={selectedCourse?.profilePhoto || UtilityFunctions.getImageURL() + "user-bg-dark.png"} />
                                                                {/* // src={selectedCourse?.employer?.logo || UtilityFunctions.getImageURL() + "bildeing-squre-img.png"}/> */}
                                                                {/* {selectedCourse?.user?.referralUsedCount >= 2 */}
                                                                <p className="mb-0" style={{

                                                                    background: "#9256e8",
                                                                    width: "100%",
                                                                    maxWidth: "fit-content"
                                                                }}>Advanced</p>
                                                                {/* : <div></div> */}
                                                                {/* } */}
                                                            </>
                                                            :
                                                            <img alt="" src={selectedCourse?.employer?.logo || UtilityFunctions.getImageURL() + "bildeing-squre-img.png"} />
                                                    }
                                                </div>
                                                {(selectedCourse?.user?.isVerified || selectedCourse?.employer?.user?.isVerified)
                                                    // && userTypeCookieval?.user?.type === STRING_CONSTANTS.userType.employer
                                                    ?
                                                    <div className='verified-accnt'>
                                                        <img src={UtilityFunctions.getImageURL() + "account-verified.svg"} alt="" />
                                                        Account Verified
                                                    </div> : null}
                                            </div>

                                            <div className='d-flex justify-content-between mt-18'>

                                                <h4>{
                                                    userTypeCookieval?.user.type === STRING_CONSTANTS.userType.employer ? (selectedCourse?.user?.firstName || '') : (selectedCourse?.employer?.tradingName || "")
                                                }
                                                </h4>
                                                <h5>
                                                    <img src={UtilityFunctions.getImageURL() + "Globe Location.svg"} alt="" />
                                                    {(selectedCourse?.location?.suburb ? selectedCourse?.location?.suburb : "") + (selectedCourse?.location?.state ? ", " : "") + (selectedCourse?.location?.state ? selectedCourse?.location?.state : "")}
                                                </h5>
                                            </div>
                                            <div className='label-design'>
                                                {
                                                    < a className='label-button clr-yllw'>
                                                        <img src={UtilityFunctions.getImageURL() + "line-yellow.svg"} alt="" />
                                                        {userTypeCookieval?.user.type === STRING_CONSTANTS.userType.employer ?
                                                            modifiedSalaray(selectedCourse?.minSalary, selectedCourse?.maxSalary, selectedCourse?.jobType, selectedCourse?.salaryCheckoutType) :
                                                            modifiedSalaray(selectedCourse?.minSalary, selectedCourse?.maxSalary, selectedCourse?.type, selectedCourse?.salaryCheckoutType)}
                                                    </a>}
                                                <a className='label-button clr-pink'>
                                                    <img src={UtilityFunctions.getImageURL() + "clock-icon.svg"} alt="" />
                                                    {UtilityFunctions.convertMonthsToYearsAndMonths(selectedCourse?.experience) + 'Experience'}
                                                </a>

                                                {userTypeCookieval?.user.type === STRING_CONSTANTS.userType.employer ? <>
                                                    {selectedCourse?.category?.map((category) => {
                                                        return (<a key={category?.id} className='label-button clr-yllw'>
                                                            <img src={UtilityFunctions.getImageURL() + "line-yellow.svg"} alt="" />

                                                            {category.name}</a>)
                                                    })}
                                                    {selectedCourse?.subCategory.map((subcategory) => {
                                                        return (
                                                            <a key={subcategory?.id} className='label-button clr-blue'>
                                                                <img src={UtilityFunctions.getImageURL() + "two-line-blue.svg"} alt="" />
                                                                {subcategory.name}
                                                            </a>
                                                        )
                                                    })}
                                                </> :
                                                    <>
                                                        <a className='label-button clr-yllw'>
                                                            <img src={UtilityFunctions.getImageURL() + "line-yellow.svg"} alt="" />
                                                            {selectedCourse?.category?.name}
                                                        </a>
                                                        <a className='label-button clr-blue'>
                                                            <img src={UtilityFunctions.getImageURL() + "two-line-blue.svg"} alt="" />
                                                            {selectedCourse?.subCategory.name}
                                                        </a>
                                                    </>
                                                }
                                            </div>
                                        </div>
                                        <div className='bordr-grdnt'></div>
                                        {userTypeCookieval?.user.type === STRING_CONSTANTS.userType.employer ?
                                            <div className='profile-detail-top'>
                                                <h6>About {(selectedCourse?.user?.firstName || '')}</h6>
                                                {/* {!selectedCourse?.chatIsActive ? <><div className="box-design d-flex align-items-center gap-3">
                                                    <img src={UtilityFunctions.getImageURL() + "EyeOffGreen.svg"} alt="" />
                                                    <p className="mb-0">Profile is hidden until chat request is accepted</p>
                                                </div>

                                                </>
                                                    : */}
                                                <>
                                                    <p>
                                                        {selectedCourse?.about}
                                                    </p>
                                                    {selectedCourse?.introductoryVideo &&
                                                        <div className="videos_react_chet">
                                                            <ReactPlayer
                                                                controls={true}
                                                                // onReady={() => { playVideo && setPlayVideo(true) }}
                                                                // playsinline={playVideo}
                                                                width='100%'
                                                                height='100%'
                                                                playIcon={<img className="play-icon" src={UtilityFunctions.getImageURL() + "play-video-button.svg"} alt='' />}
                                                                light={selectedCourse?.thumbnail ? <img className="video-thumbnail" onClick={() => setPlayVideo(true)} src={selectedCourse?.thumbnail} alt='' /> : false}
                                                                // playing={playVideo}
                                                                playing
                                                                // light={true}
                                                                url={selectedCourse?.introductoryVideo} />
                                                        </div>}
                                                    <div className="profile-detail-media-object">
                                                        {
                                                            selectedCourse?.educations?.length ?
                                                                <div className="media-object-pro">
                                                                    <h3 className="text-start mt-0">Education / Qualifications</h3>
                                                                    {selectedCourse?.educations.map(education =>
                                                                        <>
                                                                            <div className="d-flex align-items-center justify-content-between">
                                                                                <div className="d-flex align-items-center">
                                                                                    <img src={UtilityFunctions.getImageURL() + "hat-graduation.svg"} alt="" />
                                                                                    <div className="">
                                                                                        <h4 className="m-0">{education?.institutionName}</h4>
                                                                                        <h6 className="m-0">{education?.course?.name ? education?.course?.name : ""}</h6>
                                                                                    </div>
                                                                                </div>
                                                                                <p className="mb-0">{moment(education?.startDate).format("YYYY") + " - " + (education?.endDate ? moment(education?.endDate).format("YYYY") : "Present")}</p>
                                                                            </div>
                                                                            <hr />
                                                                        </>)}
                                                                </div> : <div></div>
                                                        }
                                                        {/* SHOWING PREVIOUS EXPERIENCE ONLY ADVANCE PROFILE IS UNLOCKED */}
                                                        {(selectedCourse?.experienceHistory?.length && selectedCourse?.user?.referralUsedCount >= 2) ?
                                                            <div className="media-object-pro pink-medi">
                                                                <h3 className="text-start mt-0">Previous Experience</h3>
                                                                {selectedCourse?.experienceHistory?.map(experience =>
                                                                    <><div className="d-flex align-items-center justify-content-between">
                                                                        <div className="d-flex align-items-center">
                                                                            <img src={experience?.employer?.logo || UtilityFunctions.getImageURL() + "pink-building.svg"} className={experience?.employer?.logo ? "p-0" : ""} alt="" />
                                                                            <div className="">
                                                                                <h4 className="m-0">{experience?.employer ? experience?.employer?.tradingName : experience?.unregisteredEmployer || "N/A"}</h4>
                                                                                <h6 className="m-0">{experience?.subCategory?.[0]?.name || "N/A"}</h6>
                                                                            </div>
                                                                        </div>

                                                                        <p className="mb-0"> {!experience?.startDate ? "N/A" : (experience?.endDate == null && experience?.startDate !== null
                                                                            ? `${moment(experience?.startDate).format("YYYY")} -  Present`
                                                                            : experience?.endDate == null && experience?.startDate == null
                                                                                ? 'N/A'
                                                                                : `${moment(experience?.startDate).format("YYYY")} -  ${moment(experience?.endDate).format("YYYY")}`)}</p>
                                                                    </div>
                                                                        <hr /></>)}
                                                            </div>
                                                            : <div></div>
                                                        }
                                                    </div>



                                                </>
                                            </div>
                                            :
                                            <div className='profile-detail-top'>
                                                <h6>About {(selectedCourse?.title || '')}</h6>
                                                <p>
                                                    {selectedCourse?.description && parse(selectedCourse?.description)}
                                                </p>
                                                {userTypeCookieval?.user.type === STRING_CONSTANTS.userType.course && <>
                                                    {/* <CourseJobListing
                                                        selectedCourse={selectedCourse?.id}
                                                        employerId={selectedCourse?.employer?.id}
                                                        employerTitle={selectedCourse?.title}
                                                        setSelectedCourse={props?.setSelectedCourse}
                                                        getUpdatedId={getUpdatedId}
                                                    /> */}
                                                    <></>

                                                </>}
                                                {/* {!selectedCourse?.chatIsActive ? <div className="box-design d-flex align-items-center gap-3">
                                                    <img src={UtilityFunctions.getImageURL() + "EyeOffGreen.svg"} alt="" />
                                                    <p className="mb-0">Profile is hidden until chat request is accepted</p>
                                                </div> : */}
                                                <>
                                                    {selectedCourse?.introductoryVideo &&
                                                        <div className="videos_react_chet">
                                                            <ReactPlayer
                                                                controls={true}
                                                                width='100%'
                                                                height='100%'
                                                                // light={true}
                                                                url={selectedCourse?.introductoryVideo} />
                                                        </div>
                                                    }

                                                </>
                                            </div >

                                        }
                                    </div >
                                    <div className="profil-bot-la text-white">
                                        {userTypeCookieval?.user?.type !== STRING_CONSTANTS.userType.employer ? <div className="text-white w-100 align-bottom my-3">Posted {moment(selectedCourse?.createdAt).fromNow()}</div> : ""}
                                        <div className="d-flex align-items-center justify-content-around">
                                            {handleChatButton(selectedCourse)}
                                        </div>
                                    </div>
                                </div >
                            </>}
                </div >
            </div >
        </>
    );
}

export default CourseSidebar;